<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="returnFormReference">
      <template slot="combo">
        <v-combobox outlined dense v-model="modelObj.win_numbers" :rules="[]" :items="modelObj.win_numbers" hide-selected
          :hint="$t('message.common.useEnterToAddMore')"
         :label="$t('message.productionOrder.win')" multiple persistent-hint small-chips></v-combobox>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      modelObj: {
        id: this.$route.params.id
      },
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'return_forms'
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'isLoggedIn']),
    formReferences () {
      const props = {
        title: this.$route.params.id ? this.$t('message.returnForm.update') : this.$t('message.returnForm.add'),
        properties: [{
          model: 'companyname',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.returnForm.companyName'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'companynumber',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.returnForm.companyNo'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.modelObj.email ? this.$_emailValidation : this.$_requiredValidation,
          label: this.$t('message.customer.email'),
          class: 'lg3 sm6'
        }, {
          model: 'mobile',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.mobile'),
          class: 'lg3 sm6'
        }, {
          type: this.FORM_TYPE.COMBOBOX,
          class: 'lg3 md3 sm9 pa-2',
          iscustomer: true
        }, {
          model: 'description',
          type: this.FORM_TYPE.TEXTAREA,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.description'),
          class: 'lg3 sm6',
          change: this.changesMade,
          rows: 3
        }],
        buttons: [{
          name: 'saveupdate_handler',
          color: 'success',
          label: this.$route.params.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: this.$route.params.id ? this.isLoggedIn : true
        }, {
          name: 'updateclose_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.isLoggedIn && this.$route.params.id
        }]
      }
      return props
    }
  },
  watch: {},
  mounted () {
    this.$store.dispatch('getUsers')
    if (this.modelObj.id) {
      this.getSingleRecordHandler()
    }
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data.module === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (data.handler === 'item') {
          this.$router.push(`/${this.MODULE_URL}`)
        }
      }
    })
  },
  methods: {
    supportingList (type, text) {
      text = this.$refs.returnFormReference.$refs[text][0].lazySearch
      const model = { module: type, dialog: true, text }
      this.$store.commit('supportingList', model)
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`returnform/${this.modelObj.id}`)
        .then((result) => {
          if (result && result.data) {
            const model = this.$formatter.cloneVariable(result.data)
            model.win_numbers = model.win_numbers ? JSON.parse(model.win_numbers) : []
            this.modelObj = model
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.returnFormReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.$formatter.cloneVariable(this.modelObj)
        if (model.win_numbers) model.win_numbers = JSON.stringify(model.win_numbers)
        const url = 'returnform'
        this.$_saveUpdateHandler(url, model, true)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
            else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    navigateHandler (type, id) {
      if (this.$route.params.id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
      else if (type === this.SAVE && id) this.$router.push(`/${this.MODULE_URL}/actions/${id}`)
      else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
    },
    deleteHandler () {
      const ids = [this.modelObj.id]
      const payload = { ids, url: 'returnform/delete_multiple', module: { module: this.MODULE_URL, handler: 'item' } }
      this.$store.commit('showDeleteDialog', payload)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style></style>
